import React, {Suspense, useState} from "react";
import Modal from "react-modal";
import useOnInteractionModalStore from "./components/onInteractionModal/useOnInteractionModalStore";
import Scene from "./components/three/Scene";
import {isMobile} from "./utils";
import DesktopUI from "./components/DesktopUI";
import MobileUI from "./components/MobileUI";
import Onboarding from "./components/Onboarding";
import OnBoardingInstructions from "./components/OnBoardingInstructions";
import OnBoardingInstructionsMobile from "./components/OnBoardingInstructionsMobile";
import AmbientSound from "./components/AmbientSound";
import useStore from "./store";

Modal.setAppElement("#root");

function App() {
  return (
    <div className="absolute inset-0">
      <Suspense fallback={<h1>Cargando...</h1>}>
        <Scene />

        {isMobile() ? <MobileUI /> : <DesktopUI />}

        <OnBoardingMngr />

        <AmbientSound />
      </Suspense>
    </div>
  );
}

const OnBoardingMngr = () => {
  const [showOnboarding, setShowOnBoarding] = useState(true);
  const toggleShowOnboarding = useStore((state) => state.toggleShowOnboarding);

  const toggleOnboarding = () => {
    toggleShowOnboarding();
    setShowOnBoarding((isShowing) => !isShowing);
  };

  const {showContent} = useOnInteractionModalStore();

  return (
    <>
      {showOnboarding && (
        <Onboarding
          onStart={() => {
            toggleOnboarding();
            if (isMobile()) {
              showContent(<OnBoardingInstructionsMobile />, false, true);
            } else {
              showContent(<OnBoardingInstructions />, false);
            }
          }}
        />
      )}
    </>
  );
};

export default App;
